module.exports = __webpack_public_path__ + "img/ico-union-pay.0ddedc6b.svg";